import { styled } from '@mui/material';
import SingleLineText from './SingleLineText';

const InformationMessage = ({ text }: { text: string }) => {
  return (
    <InformationMessageContainer>
      <SingleLineText text={text} />
    </InformationMessageContainer>
  );
};

export default InformationMessage;
export { InformationMessage };

const InformationMessageContainer = styled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px;
    background-color: ${theme.palette.neutral[10]};
    border-radius: 10px;
    `,
);
